import ReactGA from 'react-ga4';
import CookieService from './CookieService';

const analyticsEnabled = process.env.REACT_APP_ENABLE_ANALYTICS === 'true';

class GoogleAnalyticsService {
    init() {
        if (!analyticsEnabled) return;

        ReactGA.initialize('G-FR4SW7GYRR');

        const cookieService = new CookieService();
        const userId = cookieService.getCookie('_gtmUID');

        if (userId != undefined && userId.length > 0) {
            ReactGA.set({ userId: userId });
        }

        ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
    }

    logPageview(path) {
        if (!analyticsEnabled) return;
        ReactGA.send({ hitType: 'pageview', page: path });
    }

    setUserId(userId) {
        const cookieService = new CookieService();
        cookieService.setCookie({ name: '_gtmUID', value: btoa(userId) }, 180);
        if (!analyticsEnabled) return;
        ReactGA.set({ userId: btoa(userId) });
    }
}

const GAService = new GoogleAnalyticsService();

export default GAService;